import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Management/NetworkList';

class Email extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="email"/>}/>
      </Switch>
    )
  }
}

module.exports = Email;



// WEBPACK FOOTER //
// ./routes/app/routes/management/emails/index.js